import { getBaseUrlVersioned } from "../../../services/axiosClient";
import { API_VERSION } from "../../types";
const API_PATH_MEDIA_FILES = "media/files";
/**
 * Builds `GET /v1/media/files/{file_id}`. The path segment is `file_id` on the
 * wire; the client identifier is always `id`.
 */
export default function buildGetMediaFileByIdUrl(id) {
    return `${getBaseUrlVersioned(API_VERSION.V1)}/${API_PATH_MEDIA_FILES}/${encodeURIComponent(id)}`;
}
